/**
 * 동기화 버튼 컴포넌트
 */

import { useNavigate } from "react-router-dom";
import { useSyncQueue } from "@/hooks/useSyncQueue";

export function SyncButton() {
  const navigate = useNavigate();
  const { pendingCount, isSyncing } = useSyncQueue();

  return (
    <button
      onClick={() => navigate("/sync")}
      className="relative flex h-9 w-9 items-center justify-center rounded-lg text-slate-400 transition-colors hover:bg-slate-700 active:bg-slate-600"
      aria-label="동기화"
    >
      {/* 동기화 아이콘 */}
      <svg
        className={`h-5 w-5 ${isSyncing ? "animate-spin" : ""}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>

      {/* 대기 중인 항목 배지 */}
      {pendingCount > 0 && (
        <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white">
          {pendingCount > 9 ? "9+" : pendingCount}
        </span>
      )}
    </button>
  );
}

export default SyncButton;
